import React from 'react';
import { useTranslation } from 'react-i18next';
const TraceabilityPackaging = (props) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "traceability-packaging-content" },
        React.createElement("h2", { className: "title primary-l-u" }, props.title),
        React.createElement("p", { className: "subtitle primary-s" }, props.description)));
};
export default TraceabilityPackaging;
